import type { Post } from '../model/contracts'

export interface KeywordFrequency {
  label: string
  count: number
}

export interface DigestData {
  totalCount: number
  sentimentSplit: {
    pos: number
    neg: number
    neu: number
  }
  topKeywords: KeywordFrequency[]
}

export function computeDigest(posts: Post[]): DigestData {
  const totalCount = posts.length

  let pos = 0
  let neg = 0
  let neu = 0
  const keywordMap = new Map<string, number>()

  for (const post of posts) {
    if (post.sentiment === 'positive') pos++
    else if (post.sentiment === 'negative') neg++
    else neu++

    const tags = post.aiTags ?? post.tags ?? []
    for (const tag of tags) {
      const key = tag.toLowerCase().trim()
      if (key.length > 0) {
        keywordMap.set(key, (keywordMap.get(key) ?? 0) + 1)
      }
    }
  }

  const topKeywords = Array.from(keywordMap.entries())
    .sort((a, b) => b[1] - a[1])
    .slice(0, 10)
    .map(([label, count]) => ({ label, count }))

  return {
    totalCount,
    sentimentSplit: { pos, neg, neu },
    topKeywords,
  }
}
